<ng-content></ng-content>

<div class="menu-container" [ngClass]="{'compact': compactMode}">
  <div class="mobile-menu-button dx-item dx-treeview-item" (click)="toggleMenu()">
    <span class="material-symbols-outlined nav-icon">close</span>
    <span class="nav-title">Close</span>
  </div>
  <dx-tree-view class="menu-tree-view"
                itemTemplate="navTemplate"
                keyExpr="name"
                selectionMode="single"
                expandEvent="click"
                width="100%"
                [items]="sideNavItems"
                [selectedExpr]="'isSelected'"
                [focusStateEnabled]="true"
                [ngClass]="{'compact': compactMode}"
                (onItemClick)="onItemClick($event)"
                (onItemExpanded)="onItemExpanded($event)">
    <div *dxTemplate="let item of 'navTemplate'">
      <span class="material-symbols-outlined icon-filled nav-icon">{{item.icon}}</span>
      <span class="nav-title">{{item.name}}</span>
    </div>
  </dx-tree-view>

  <div class="nav-footer" [ngClass]="{'compact': compactMode}">
    <dx-button class="menu-button"
               stylingMode="text"
               (onClick)="toggleMenu()">
      <span class="material-symbols-outlined">
        {{ compactMode ? 'last_page' : 'first_page' }}
      </span>
    </dx-button>
  </div>
</div>
